<template>
  <div class="padding">
    <!-- <FormInput
      v-model="$v.site.$model"
      :disabled="disabled"
      :vuelidate="$v"
      fieldName="site"
      :ske="true"
      :focus="true"

      id="site"
      label="Website"
    /> -->
    <div :class="isEdit && 'd-flex'">
      <FormSearchSelector v-model="$v.site.$model"
        class="sm form-element"
        id="website"
        label="Website"
        placeholder="Zoek website..."
        endpoint="/api/websites"
        titleField="domainname"
        searchParameter="name"
        max-height="370px"
        :ske="editing"
        :disabled="isEdit ? disabled || showRemark : false"
        :initial-search-value="$v.siteName.$model"
        :get-name-from-endpoint="true"

        @select-item="getWebsiteName"

        :infinite-scrolling="true"

        v-slot="item"
      >
        <div class="px-2 item">
          {{ item.domainname }}
        </div>
      </FormSearchSelector>

      <FormInput v-show="isEdit"
        class="sm form-element"
        v-model="$v.orderNumber.$model"
        :disabled="true"
        :ske="true"
        fieldName="orderNumber"

        id="orderNumber"
        label="Bestellingsnummer"
      />
    </div>
    <FormTextarea v-if="showRemark"
      v-model="vuelidate.remark.$model"
      placeholder="Remark..."
      class="mt-3"
      :ske="true"
      :disabled="editableRemark"
      rows="17"

      ref="textarea"
    />
    <!-- <div class="d-flex">
      <FormSelect
        class="sm form-element"
        v-model="$v.language.$model"
        :disabled="disabled"
        :ske="true"
        :vuelidate="$v"
        :options="shortLanguageOptions"
        fieldName="language"

        id="language"
        label="Taal"
      />
    </div> -->
    <!-- <FormInput
      v-model="$v.shipmentTrackAndTrace.$model"
      :disabled="disabled"
      :ske="true"
      :vuelidate="$v"
      fieldName="shipmentTrackAndTrace"

      id="shipmentTrackAndTrace"
      label="Track en trace"
    /> -->
  </div>
</template>

<script>

import FormInput from "/src/components/Inputs/FormInput.vue"
import FormTextarea from "/src/components/Inputs/FormTextarea.vue"
import FormSelect from "../Inputs/FormSelect.vue"
import WebsiteItem from "../../pages/website-products/Table/WebsitesColumn/WebsiteItem.vue"
import FormSearchSelector from "../Inputs/FormSearchSelector.vue"
import ProductListItem from "../Product/ProductListItem.vue"

import setupForm from "../../mixins/setupForm"
import { required } from "vuelidate/lib/validators"

import tableFieldOptions from "../../mixins/tableFieldOptions"

const decimal = value => (value + "").replace(/,/, ".").match(/^[-]?\d*(\.\d+)?$/) ? true : false

export default setupForm(
  ["site", "orderDate", "orderNumber", "language", "siteName"], {
  mixins: [tableFieldOptions],
  components: {
    FormSelect,
    ProductListItem,
    FormInput,
    FormSearchSelector,
    FormTextarea,
  },
  props: {
    disabled: Boolean,
    loading: Boolean,
    editing: Boolean,
    showRemark: Boolean,
    vuelidate: Object,
    editableRemark: Boolean,
    isEdit: [Boolean, String]
  },
  data() {
    return {
      language: "NL",
    }
  },

  async mounted() {
    if (!this.showRemark) {
      await this.getOrderNumber()
    } else {
      this.$v.siteName.$model = this.$v.site.$model
    }
  },
  methods: {
    async getOrderNumber() {
      const {data: { orderNumber } } = await this.axios.get('/api/orders/next-order-number')
      this.$v.orderNumber.$model = orderNumber
    },
    getWebsiteName(item) {
      if (!item) return;
      this.$v.siteName.$model = item.domainname
      this.$v.site.$model = item.domainname
    },
  },
  watch: {
    loading(val) {
      if (!val) {
        this.$v.siteName.$model = this.$v.site.$model
      }
    },
  },
  validations: {
    siteName: {
      required,
    },
    remark: {

    },
    site: {
      required,
    },
    orderNumber: {
      decimal,
    },
    language: {
      required,
    },
  }
})

</script>

<style scoped src="@/assets/css/form.css"></style>

<style scoped>

input {
  width: 120px;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 6px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  transform: translate(2px, 0px);
}

.item {
  transition-duration: .15s;
}

.item:hover {
  background-color: rgba(243, 244, 246, 1) !important;
}

</style>
